export default {
    comingSoon: "The page is still in development"
}